module.exports = __webpack_public_path__ + "assets/lessons/en/lesson3/pages/lesson_3_11.pdf";